import type { QueueAdmissionView } from '../queue/queue-admission.policy.js';
import type { ResourceBudgetView } from '../queue/resource-budget.policy.js';

export const JOB_SOURCES = {
  'telegram-publishing': 'Публикация анкет',
  fakes: 'Карта выдачи',
  'fakes-reports': 'Отчёты карты',
  positions: 'Позиции',
  metrics: 'Метрики',
  alerts: 'Алерты',
  'donor-import': 'Импорт доноров',
  'donor-checks': 'Проверки доноров',
  'donor-reports': 'Отчёты доноров',
  topvisor: 'Topvisor',
  n8n: 'Реестр n8n',
} as const;
export type JobSource = keyof typeof JOB_SOURCES;
export const JOB_STATES = {
  queued: 'В очереди',
  running: 'Выполняется',
  scheduled: 'По расписанию',
  waiting: 'Ожидает зависимость',
  retrying: 'Повтор',
  paused: 'Приостановлено',
  complete: 'Завершено',
  partial: 'Частичный результат',
  failed: 'Ошибка',
  cancelled: 'Отменено',
  unknown: 'Результат неизвестен',
} as const;
export type JobState = keyof typeof JOB_STATES;
export interface Job {
  key: string;
  source: JobSource;
  title: string;
  state: JobState;
  stage: string | null;
  createdAt: string | null;
  startedAt: string | null;
  completedAt: string | null;
  updatedAt: string | null;
  dueAt: string | null;
  total: number | null;
  processed: number | null;
  failed: number | null;
  attempts: number | null;
  maxAttempts: number | null;
  error: string | null;
  href: string;
  children: boolean;
}
export interface JobsQuery {
  view?: 'active' | 'attention' | 'history';
  source?: JobSource;
  state?: JobState;
  period?: '30' | 'all';
  page?: number;
  pageSize?: number;
}
export interface JobSourceStatus {
  source: JobSource;
  available: boolean;
  error: string | null;
  history: string;
  worker: string;
  lastSeenAt: string | null;
}
export interface JobsPage {
  resourceBudget?: ResourceBudgetView;
  queueAdmission?: QueueAdmissionView;
  items: Job[];
  total: number;
  page: number;
  pageSize: number;
  observedAt: string;
  sources: JobSourceStatus[];
}
export interface JobDetail {
  resourceBudget?: ResourceBudgetView;
  queueAdmission?: QueueAdmissionView;
  job: Job;
  items: Job[];
  total: number;
  page: number;
  pageSize: number;
  observedAt: string;
}
